"use client"

import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { Menu, X, User, LogOut, Wallet } from "lucide-react"

const Navbar = () => {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleLogout = () => {
    logout()
    navigate("/")
    setIsMenuOpen(false)
  }
  const klik = () =>{
    setIsMenuOpen(false)
  }

  return (
    <nav className="bg-black text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">NG</span>
              </div>
              <span className="font-bold text-xl">DataHub</span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {user ? (
              <>
                <Link to="/dashboard"  className="hover:text-blue-400 transition-colors">
                  Dashboard
                </Link>
                <Link to="/buy-data" className="hover:text-blue-400 transition-colors">
                  Buy Data
                </Link>
                <Link to="/buy-airtime" className="hover:text-blue-400 transition-colors">
                  Buy Airtime
                </Link>
                <Link to="/pay-bills" className="hover:text-blue-400 transition-colors">
                  Pay Bills
                </Link>
                <div className="flex items-center space-x-4">
                  <Link to="/wallet" className="flex items-center space-x-1 bg-blue-600 px-3 py-1 rounded-full text-sm">
                    <Wallet size={16} />
                    <span>₦{user.balance?.toLocaleString() || "0"}</span>
                  </Link>
                  <div className="relative group">
                    <button className="flex items-center space-x-1 hover:text-blue-400">
                      <User size={20} />
                      <span>{user.name}</span>
                    </button>
                    <div className="absolute right-0 mt-2 w-48 bg-white text-black rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                      <Link to="/profile" className="block px-4 py-2 hover:bg-gray-100">
                        Profile
                      </Link>
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center space-x-2"
                      >
                        <LogOut size={16} />
                        <span>Logout</span>
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex items-center space-x-4">
                <Link to="/login" className="hover:text-blue-400 transition-colors">
                  Login
                </Link>
                <Link to="/register" className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded-md transition-colors">
                  Register
                </Link>
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-white hover:text-blue-400">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-gray-700">
              {user ? (
                <>
                  <Link to="/dashboard"  onClick={()=>klik()} className="block px-3 py-2 hover:bg-gray-800 rounded-md">
                    Dashboard
                  </Link>
                  <Link to="/buy-data" onClick={()=>klik()} className="block px-3 py-2 hover:bg-gray-800 rounded-md">
                    Buy Data
                  </Link>
                  <Link to="/buy-airtime" onClick={()=>klik()} className="block px-3 py-2 hover:bg-gray-800 rounded-md">
                    Buy Airtime
                  </Link>
                  <Link to="/pay-bills" onClick={()=>klik()} className="block px-3 py-2 hover:bg-gray-800 rounded-md">
                    Pay Bills
                  </Link>
                  <Link to="/wallet" onClick={()=>klik()} className="block px-3 py-2 hover:bg-gray-800 rounded-md">
                    Wallet (₦{user.balance?.toLocaleString() || "0"})
                  </Link>
                  <Link to="/profile" onClick={()=>klik()} className="block px-3 py-2 hover:bg-gray-800 rounded-md">
                    Profile
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-3 py-2 hover:bg-gray-800 rounded-md"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="block px-3 py-2 hover:bg-gray-800 rounded-md">
                    Login
                  </Link>
                  <Link to="/register" className="block px-3 py-2 hover:bg-gray-800 rounded-md">
                    Register
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar
